import {
  SetAccessUser,
  AuthActionsTypes,
  AuthActions,
} from 'libs/rx-photo-state/state/actions/auth.action';

export interface AuthState {
  access: boolean;
}

const initialState: AuthState = {
  access: false,
};

export function AuthReducer(state = initialState, action: AuthActions): AuthState {
  switch (action.type) {
    case AuthActionsTypes.SetAccessUser:
      return { ...state, access: action.payload };

    default:
      return state;
  }
}
